import { graphql } from 'gatsby';

/**
 * === MAP ARTICLE WIDGET PARAMS ======================================================
 * @param {Object} props of the widget
 * @param {string} locale of the props
 */
export const mapArticleWidgetProps = (props, locale) => {
  /* === RETURN ======================================================================= */
  return {
    key: props?.key,
    label: props.label,
    children: props?.[`children_${locale}`],
    direction: props?.direction,
    title: props?.[`title_${locale}`],
    subtitle: props?.[`subtitle_${locale}`],
    description: props?.[`description_${locale}`],
    images: props?.images?.map((img) => img?.large?.childImageSharp?.fluid) ?? [],
    disclaimer: props?.[`disclaimer_${locale}`],
    cta: {
      position: props?.ctaPosition,
      text: props?.[`ctaText_${locale}`],
      url: props?.[`ctaUrl_${locale}`],
    },
    backgroundColor: props?.backgroundColor,
    contentAlignment: props?.contentAlignment,
    containerId: props?.containerId,
  };
};

/**
 * GraphQL Query
 */
export const query = graphql`
  fragment Articlelp on StrapiWidgetrels {
    articlelp {
      key: id
      label
      children_en
      children_es
      direction
      title_en
      title_es
      subtitle_en
      subtitle_es
      description_en
      description_es
      images {
        large {
          childImageSharp {
            fluid(maxHeight: 640, quality: 80) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
      disclaimer_en
      disclaimer_es
      ctaPosition
      ctaText_en
      ctaText_es
      ctaUrl_en
      ctaUrl_es
      backgroundColor
      contentAlignment
      containerId
      widgetPosition
    }
  }
`;
